import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { ShieldCheck } from 'lucide-react';
import logo from '../assets/logo.jpg';

// Staff-only login page — not linked anywhere in the customer-facing UI.
// Access via: /staff/login
const StaffLogin = () => {
  const [error, setError] = useState(null);
  const { signInWithSSO } = useAuth();

  const handleSSO = async () => {
    setError(null);
    const { error } = await signInWithSSO();
    if (error) setError(error.message);
  };

  return (
    <div
      style={{
        maxWidth: '360px',
        margin: '120px auto',
        padding: '32px 24px',
        backgroundColor: 'var(--bg-card)',
        borderRadius: '16px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
        textAlign: 'center',
      }}
    >
      <img
        src={logo}
        alt="Leaf & Letter"
        style={{ height: '64px', borderRadius: '12px', marginBottom: '20px' }}
      />
      <h2 style={{ color: 'var(--text-main)', marginBottom: '6px' }}>Staff Portal</h2>
      <p style={{ color: 'var(--text-soft)', fontSize: '0.85rem', marginBottom: '28px' }}>
        Authenticate with your Sanctuary ID to continue.
      </p>

      {error && (
        <p style={{ color: '#e05252', fontSize: '0.85rem', marginBottom: '16px' }}>{error}</p>
      )}

      <button
        onClick={handleSSO}
        style={{
          width: '100%',
          padding: '14px',
          borderRadius: '10px',
          border: 'none',
          backgroundColor: 'var(--accent)',
          color: 'white',
          fontWeight: 'bold',
          cursor: 'pointer',
          fontSize: '1rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '10px',
          boxShadow: '0 4px 12px var(--accent-soft)',
        }}
      >
        <ShieldCheck size={20} /> Sign in with Sanctuary ID
      </button>
    </div>
  );
};

export default StaffLogin;
